import React from 'react';
import classnames from 'classnames';
import { Basic, Part } from 'Shared/PageLayout';
import { translate } from 'Shared/translate';
import NutritionFacts from 'Shared/NutritionFact/NutritionFacts';
import * as styles from './base.scss';
export default class ProductDescription extends React.Component {
    constructor(props) {
        super(props);
    }
    render() {
        return this.props.tableData && this.props.tableData.length > 0 ? (React.createElement(Basic, { appearance: "default", className: classnames(styles.base, this.props.className) },
            React.createElement("div", { className: styles.productDescription, id: "productDescription" },
                this.props.text && (React.createElement("div", null,
                    React.createElement("div", { className: styles.title }, translate('/Product/Description')),
                    React.createElement("p", null, this.props.text))),
                React.createElement("div", { className: styles.flexWrapper },
                    this.props.list && (React.createElement(Part, { className: styles.flexWrapper__left },
                        React.createElement("b", null, translate('/Product/ArticleInformation')),
                        this.props.list)),
                    React.createElement(Part, { className: styles.flexWrapper__right })),
                !!this.props.tableData && this.props.tableData.length > 0 && (React.createElement("div", null,
                    React.createElement(NutritionFacts, { nutritionInformationProvider: this.props.nutritionInformationProvider, tableData: this.props.tableData })))))) : null;
    }
}
